import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { select } from '@ngrx/store';
import { ChatScopEnum } from 'app/main/signing-pages/activity-logs/activity-form/activity-form.component';
import { selectUserSetting } from 'app/store/reducers/user_settings.reducer';
import { UserSettingsFacade } from 'app/store/user-settings.facade';
import { filter, take } from 'rxjs';
import { UserSettings } from '../../../../../global/user-settings.dto';
import { ActivityLogs, SignableType } from '../activity-logs-dto';


@Component({
  selector: 'app-activity-log-messages',
  templateUrl: './activity-log-messages.component.html',
  styleUrl: '../activity-logs.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ActivityLogMessagesComponent implements OnInit {
  @Input() roleId: number = 0;
  @Input() is_sender: number = 0;
  @Input() activity: ActivityLogs = {} as ActivityLogs;
  
  public loggedInUser: UserSettings = {} as UserSettings;
  public chatScopeEnum = ChatScopEnum;
  protected readonly Number = Number;
  public signableType = SignableType;
  constructor(private _userSettingsFacade$: UserSettingsFacade) {}

  ngOnInit(): void {
    this._userSettingsFacade$._userSettings$.pipe(
      filter(userSettings => !!userSettings),
      take(1),
      select(selectUserSetting)
    ).subscribe((user_settings) => {
      if(this.is_sender == 1) {
        this.loggedInUser = user_settings;
      }
    });
  }

  get chatClass(): string {
    if(this.is_sender === 1){
      return this.isUserModal ? 'chat-right' : 'chat-left';
    }
    return this.is_sender === 0 && this.isRecipientModal ? 'chat-right' : 'chat-left';
  }



  get isRecipientModal(): boolean {
    return this.activity.signable_type?.indexOf('RecipientRole') > -1 && this.roleId == this.activity.signable.id;
  }



  get isUserModal(): boolean {
    return this.activity.signable_type?.indexOf('User') > -1 && this.loggedInUser?.id  === this.activity.signable.user_id;
  }

  /**
   * Return an initial colors
   * @param color 
   * @param opacity 
   * @returns color
   */
  addAlpha(color: string, opacity: number): string {
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
  }

    
}

